<script lang="ts" setup>
	const imgList = [
		{
			name: 'ventures',
			sm: 'MCG/investors/ddnn6pape1cnacmuipbu',
			lg: 'MCG/investors/yjmbb7gjsqje4xpvv53y'
		},
		{
			name: 'techstars',
			sm: 'MCG/investors/w6jwx8zp9ha2dtnd7kdt',
			lg: 'MCG/investors/kfh4anaeeevazp4polog'
		},
		{
			name: '54-collective',
			sm: 'MCG/investors/mzfa2dcmfpiggyccvlhx',
			lg: 'MCG/investors/jeuachwefacuzfkwep1i'
		}
	]
</script>

<template>
	<div>
		<ui-title-header
			title="Big dreams need strong backers. <br /> Meet the visionaries behind us."
			:ui="{
				size: 'text-[2rem]/[2.4rem] md:text-[2.625rem]/[3.15rem] lg:text-[3.25rem]/[4.55rem]',
				lineHeight: 'sm:leading-[140%]'
			}"
			class="text-center"
		/>
		<div
			class="items-center sm:grid xl:flex xl:justify-between grid-cols-3 gap-4 overflow-hidden py-16 flex justify-center place-items-center w-full flex-wrap"
		>
			<nuxt-img
				v-for="(item, index) in imgList"
				:key="index"
				:src="item.sm"
				:alt="item.name"
				placeholder
				loading="lazy"
				class="max-w-[370px] w-full rounded-xl"
			/>
		</div>
	</div>
</template>
